"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListsSink = void 0;
const list_1 = require("client/components/list");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./lists.less");
let ListsSink = class ListsSink extends react_1.Component {
    constructor() {
        super(...arguments);
        this.orderBy = "site";
    }
    renderListRow(row, index) {
        return (React.createElement("div", { className: "list-component__row", key: index },
            React.createElement("div", { className: "list-component__column--profile" },
                React.createElement("div", { className: "label" }, row.displayName),
                React.createElement("div", { className: "value" },
                    React.createElement("a", { href: "" }, row.email))),
            React.createElement("div", { className: "list-component__column" },
                React.createElement("div", { className: "label" }, "Workspace"),
                React.createElement("div", { className: "value" }, row.workspace)),
            React.createElement("div", { className: "list-component__column" },
                React.createElement("div", { className: "label" }, "Pharmacy"),
                React.createElement("div", { className: "value" }, row.site)),
            React.createElement("div", { className: "list-component__column" },
                React.createElement("div", { className: "label" }, "Group"),
                React.createElement("div", { className: "value" }, row.group)),
            React.createElement("div", { className: "list-component__column--actions" })));
    }
    render() {
        const data = [
            {
                id: 1,
                displayName: "Someone",
                email: "example@example.com",
                group: "Group one",
                site: "example.com",
                workspace: "workspace"
            },
            {
                id: 2,
                displayName: "Someone",
                email: "example@example.com",
                group: "Group one",
                site: "example.com",
                workspace: "workspace"
            },
            {
                id: 3,
                displayName: "Someone",
                email: "example@example.com",
                group: "Group one",
                site: "example.com",
                workspace: "workspace"
            }
        ];
        return (React.createElement("div", { className: "list" },
            React.createElement("h2", null, "List"),
            React.createElement(list_1.List, { data: data, renderRow: this.renderListRow })));
    }
};
__decorate([
    mobx_1.observable
], ListsSink.prototype, "orderBy", void 0);
ListsSink = __decorate([
    mobx_react_1.observer
], ListsSink);
exports.ListsSink = ListsSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/lists/lists.tsx
// module id = 3650
// module chunks = 0